/**
 * 代理店
 */
export class AgencyInfo {
    /** 都道府県コード */
    agencyPrefectureCode: string | null= null
    /** 顧客コード (999999) */
    agencyCode: string | null = null
    /** 枝番 (99) */
    agencyBranchNumber: string | null= null
    /** 代理店名称 */
    agencyName = ""
    /** 代理店略称名 */
    agencyShortName = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<AgencyInfo>) {
        Object.assign(this, init)
    }

    /**
     * 代理店コード（主キー）
     */
    get customerKey(): string {
        return this.isEmpty ? "" : `${this.agencyPrefectureCode}-${this.agencyCode}-${this.agencyBranchNumber}`
    }

    /**
     * 代理店未選択か
     */
    get isEmpty(): boolean {
        return (this.agencyPrefectureCode === null || this.agencyCode === null || this.agencyBranchNumber === null)
    }
}
